import { propValueOr } from "../../helpers/common";
import { api } from "../../index";
import MATCHES_ACTIONS from "./constants";

export const fetchMatches = query => dispatch => {
  dispatch({
    type: MATCHES_ACTIONS.list.request
  });
  api.matches
    .list(query)
    .then(resp => {
      dispatch({
        type: MATCHES_ACTIONS.list.success,
        payload: propValueOr(resp, "data", [])
      });
    })
    .catch(err => {
      dispatch({
        type: MATCHES_ACTIONS.list.error,
        payload: err
      });
    });
};

export const resetMatches = () => dispatch => {
  dispatch({
    type: MATCHES_ACTIONS.reset
  });
};
